// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Landingscreen from '../Screens/Landingscreen';
// import Projects from '../Screens/Projects';
// import About from '../Screens/About';
// import ContactUs from '../Screens/ContactUs';
// import Homescreen from '../Screens/Homescreen';
// import Footer from '../Screens/Footer';
// import TransformationShowcase from '../Screens/TransformationShowcase';
// import VideoShowcase from '../Screens/VideoShowcase';
// import ClientFeedbacks from '../Screens/ClientFeedbacks';
// import WhyChooseUs from '../Screens/WhyChooseUs';
// import AboutFounder from '../Screens/AboutFounder';
// import SplashScreen from '../Screens/SplashScreen';

// const Nav = () => {
//     const [isAppLoading, setIsAppLoading] = useState(true);
//     const appStyle = {
//         // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//         minHeight: '100vh',
//         color: 'white',
//     };


//     return (
//         <div style={appStyle}>
//             <Router> {/* This wrapper element fixes the error */}
//                 <Routes>
//                     {isAppLoading && (
//                         <SplashScreen onAnimationComplete={() => setIsAppLoading(false)} />
//                     )}
//                     <Route path="/" element={<Homescreen />} />
//                     <Route path="/Landingscreen" element={<Landingscreen />} />
//                     <Route path="/Projects" element={<Projects />} />
//                     <Route path="/About" element={<About />} />
//                     <Route path="/ContactUs" element={<ContactUs />} />
//                     <Route path="/Footer" element={<Footer />} />
//                     <Route path="/TransformationShowcase" element={<TransformationShowcase />} /> {/* 2. MAP ROUTE */}
//                     <Route path="/VideoShowcase" element={<VideoShowcase />} />
//                     <Route path="/ClientFeedbacks " element={<ClientFeedbacks />} />
//                     <Route path="/WhyChooseUs" element={<WhyChooseUs />} />
//                     <Route path="/AboutFounder" element={<AboutFounder />} />





//                 </Routes>
//             </Router>
//         </div>
//     );
// };

// export default Nav;

import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landingscreen from '../Screens/Landingscreen';
import Projects from '../Screens/Projects';
import About from '../Screens/About';
import ContactUs from '../Screens/ContactUs';
import Homescreen from '../Screens/Homescreen';
import Footer from '../Screens/Footer';
import TransformationShowcase from '../Screens/TransformationShowcase';
import VideoShowcase from '../Screens/VideoShowcase';
import ClientFeedbacks from '../Screens/ClientFeedbacks';
import WhyChooseUs from '../Screens/WhyChooseUs';
import AboutFounder from '../Screens/AboutFounder';
import SplashScreen from '../Screens/SplashScreen';
import ProjectDetails from '../Screens/ProjectDetails';
import MeetOurTeam from '../Screens/MeetOurTeam';


const Nav = () => {
    const [isAppLoading, setIsAppLoading] = useState(true);
    
    // Balanced studio design token layout config setup parameters
    const appStyle = {
        minHeight: '100vh',
        background: '#F8F6F2', // Soft Alabaster base tracking theme 
        color: '#2C302E',     // Charcoal Slate readability text main token
    };

    return (
        <div style={appStyle}>
            {/* 1. CRITICAL FIX: Moving your splash loading layer here prevents React Router compilation errors */}
            {isAppLoading && (
                <SplashScreen onAnimationComplete={() => setIsAppLoading(false)} />
            )}

            <Router> 
                <Routes>
                    {/* Your route mapping index matrix sits completely uninterrupted */}
                    <Route path="/" element={<Homescreen />} />
                    <Route path="/Landingscreen" element={<Landingscreen />} />
                    <Route path="/Projects" element={<Projects />} />
                    <Route path="/About" element={<About />} />
                    <Route path="/ContactUs" element={<ContactUs />} />
                    <Route path="/MeetOurTeam" element={<MeetOurTeam />} />

                    <Route path="/Footer" element={<Footer />} />
                    <Route path="/TransformationShowcase" element={<TransformationShowcase />} /> 
                    <Route path="/VideoShowcase" element={<VideoShowcase />} />
                    <Route path="/ClientFeedbacks" element={<ClientFeedbacks />} />
                    <Route path="/WhyChooseUs" element={<WhyChooseUs />} />
                    <Route path="/AboutFounder" element={<AboutFounder />} />
                    {/* <Route path="/ProjectDetails" element={<ProjectDetails />} /> */}
                    <Route path="/project/:id" element={<ProjectDetails />} />

                </Routes>
            </Router>
        </div>
    );
};

export default Nav;
